(function () {
  const width = window.innerWidth;
  const device = width < 750 ? 'mobile' : width < 1025 ? 'tablet' : 'desktop';
  const colorMode = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  const STORAGE_KEY = 'ascent-cart-device';
  const stored = `${device} ${colorMode}`;

  // Clarity's own queue stub, so the tag lands even when its app embed loads after this script.
  window.clarity =
    window.clarity ||
    function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
  window.clarity('set', 'color_mode', colorMode);

  if (sessionStorage.getItem(STORAGE_KEY) === stored) return;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { device, color_mode: colorMode } }),
  }).then((response) => {
    if (response.ok) sessionStorage.setItem(STORAGE_KEY, stored);
  });
})();
